import React from 'react';
import styled from 'styled-components';
import Colors from '@constants/Colors';

const Wrapper = styled.div`
  svg {
    animation: rotate 2s linear infinite;
    height: ${({ height }) => height};
    width: ${({ width }) => width};
    transform-origin: center center;
    margin: auto;
    stroke: ${Colors.periwinkleStrong};
  }

  circle {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
    animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;
    stroke-linecap: round;
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes dash {
    0% {
      stroke-dasharray: 1, 200;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 89, 200;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 89, 200;
      stroke-dashoffset: -124;
    }
  }

  ${({ rotateColors }) =>
    rotateColors &&
    ` @keyframes color {
    100%,
    0% {
      stroke: ${Colors.periwinkleStrong};
    }
    50% {
      stroke: ${Colors.tealish};
    }
  }`}
`;

const Spinner = props => {
  return (
    <Wrapper {...props}>
      <svg className="circular" viewBox="25 25 50 50">
        <circle className="path" cx="50" cy="50" r="20" fill="none" strokeWidth="5" />
      </svg>
    </Wrapper>
  );
};

Spinner.defaultProps = {
  width: '16px',
  height: '16px',
  rotateColors: true,
};

export default Spinner;
